import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { useSettings } from '@/hooks/useSettings';

export default function Datenschutz() {
  const { settings } = useSettings();

  return (
    <div data-testid="datenschutz-page">
      <Navbar settings={settings} />
      <main className="pt-28 pb-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl font-black text-slate-900 uppercase tracking-tight mb-10">Datenschutzerklärung</h1>

          <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase mt-0">1. Datenschutz auf einen Blick</h2>
            <h3 className="font-heading text-lg font-bold text-slate-800">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">2. Verantwortlicher</h2>
            <p>
              HKE Bedachung Ertel<br />
              Inhaber: Andreas Ertel<br />
              Teichplatz 7<br />
              01259 Dresden<br />
              Telefon: 0351-2038530<br />
              E-Mail: hke-bedachung@t-online.de
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">3. Datenerfassung auf dieser Website</h2>
            <h3 className="font-heading text-lg font-bold text-slate-800">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p>
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
            </p>

            <h3 className="font-heading text-lg font-bold text-slate-800">Server-Log-Dateien</h3>
            <p>
              Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind: Browsertyp und Browserversion, verwendetes Betriebssystem, Referrer URL, Hostname des zugreifenden Rechners, Uhrzeit der Serveranfrage und IP-Adresse.
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">4. Ihre Rechte</h2>
            <p>
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
            </p>
            <p>
              Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können Sie sich jederzeit an uns wenden.
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">5. Analyse-Tools und Tools von Drittanbietern</h2>
            <p>
              Diese Website verwendet keine Analyse-Tools oder Tracking-Dienste von Drittanbietern.
            </p>

            <h2 className="font-heading text-xl font-bold text-slate-900 uppercase">6. SSL- bzw. TLS-Verschlüsselung</h2>
            <p>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
          </div>
        </div>
      </main>
      <Footer settings={settings} />
    </div>
  );
}
